import * as React from 'react';

import { Box, Button, Image, MainContentWrapper, Typography } from 'components';
import { getName, getParamsFromUrl, normalizeName } from 'utils';

import { TEXT } from 'texts';
import { UrlParam } from 'enums';
import { observer } from 'mobx-react-lite';
import { successImage } from 'images';
import { useStores } from 'hooks';
import { useStyles } from './Success.styles';
import { useTranslation } from 'react-i18next';

const Success = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { dataStore, formStore } = useStores();

  const imageLink =
    getParamsFromUrl({ search: window.location.search, param: UrlParam.IMAGE_LINK, defaultValue: '' }) ||
    dataStore.selectedParticipant?.personage.imageLink;

  const name =
    normalizeName(getParamsFromUrl({ search: window.location.search, param: UrlParam.NAME, defaultValue: '' })) ||
    getName(dataStore.selectedParticipant?.personage.firstName, dataStore.selectedParticipant?.personage.lastName);

  const senderName =
    normalizeName(
      getParamsFromUrl({ search: window.location.search, param: UrlParam.SENDER_NAME, defaultValue: '' })
    ) || getName(formStore.senderName.value);

  const handleClick = () => {
    window.location.replace('https://sensebank.com.ua/');
  };

  return (
    <MainContentWrapper>
      <Box className={styles.root}>
        <Box mt={4}>
          {imageLink ? (
            <Image src={imageLink} width={256} height={256} skeletonType="circle" />
          ) : (
            <Image {...successImage} height={256} />
          )}
        </Box>
        <Box mt={3}>
          {!!name ? (
            <>
              <Typography className={styles.text} align="center">
                {t(TEXT.successDescriptionWithName, { name: senderName ? `${name} ${senderName}` : name })}
              </Typography>
              <Box mt={2}>
                <Typography textColor="grey" align="center">
                  {t(TEXT.successDescription)}
                </Typography>
              </Box>
            </>
          ) : (
            <Typography className={styles.text} align="center">
              {t(TEXT.successOperation)}
            </Typography>
          )}
        </Box>
        <Button className={styles.button} fullWidth type="button" onClick={handleClick}>
          {t(TEXT.ready)}
        </Button>
      </Box>
    </MainContentWrapper>
  );
};

export default observer(Success);
